import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getTaskComments = async (taskId) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/tasks/${taskId}/comments`,
    );
    return response.data;
  } catch (error) {
    console.error(
      'Error fetching task comments:',
      error.response?.data || error,
    );
    throw error;
  }
};

export const createTaskComment = async (taskId, data) => {
  try {
    const response = await axiosInstance.post(
      `${API_URL}/tasks/${taskId}/comments`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error(
      'Error creating task comment:',
      error.response?.data || error,
    );
    throw error;
  }
};

export const updateTaskComment = async (taskId, commentId, data) => {
  try {
    const response = await axiosInstance.put(
      `${API_URL}/tasks/${taskId}/comments/${commentId}`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error(
      'Error updating task comment:',
      error.response?.data || error,
    );
    throw error;
  }
};

export const deleteTaskComment = async (taskId, commentId) => {
  try {
    const response = await axiosInstance.delete(
      `${API_URL}/tasks/${taskId}/comments/${commentId}`,
    );
    return response.data;
  } catch (error) {
    console.error(
      'Error deleting task comment:',
      error.response?.data || error,
    );
    throw error;
  }
};
